import { Logger, NumberUtils } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { GameManager } from "./GameManager";
import { GameData } from "../Channels/Common/Datas/GameData";
import { DataManager } from "./DataManager";
import { BetManager } from "./BetManager";
import { AppContext } from "../../Common/AppContext";
import { Languages } from "../Utils/Languages";
import { ModuleManager } from "./ModuleManager";
import { CashierDialog } from "../Channels/Common/Dialogs/CashierDialog";
import { FreeRoundBonus } from "../Channels/Common/Bonuses/FreeRoundBonus";

type BalanceResponse = Communication.Game.BalanceResponse;
var GameModules = Communication.Game.GameModules;
type IBalance = Communication.Game.IBalance;

export class BalanceManager {
    private static _poolBalance: boolean = false;

    static setBalance(): void {
        if (GameManager.gameResponse.balance != null) {
            if (GameManager.gameResponse.balance.real != null) {
                DataManager.updateGameDataFromModule(
                    GameData.DataBalanceReal,
                    GameManager.gameResponse.balance.real.toString(),
                );
                if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
                    DataManager.updateGameDataFromModule(
                        GameData.DataBalanceRealDenom,
                        parseInt(
                            NumberUtils.devide(GameManager.gameResponse.balance.real, BetManager.CoinSize),
                        ).toString(),
                    );
                }
            }

            if (GameManager.gameResponse.balance.bonus != null) {
                DataManager.updateGameDataFromModule(
                    GameData.DataBalanceBonus,
                    GameManager.gameResponse.balance.bonus.toString(),
                );
            }

            if (GameManager.gameResponse.balance.real != null && GameManager.gameResponse.balance.bonus != null) {
                DataManager.updateGameDataFromModule(
                    GameData.DataBalanceTotal,
                    NumberUtils.add(GameManager.gameResponse.balance.real, GameManager.gameResponse.balance.bonus),
                );
            }
        }
    }

    static fixBalance(): void {
        let bonus: number = parseFloat(DataManager.getDataById(GameData.DataBalanceBonus));
        let real: number = parseFloat(DataManager.getDataById(GameData.DataBalanceReal));
        let realDenom: number = parseFloat(DataManager.getDataById(GameData.DataBalanceRealDenom));
        let win: number = parseFloat(DataManager.getDataById(GameData.DataTotalWin));
        let winDenom: number;
        let total: number = parseFloat(NumberUtils.add(bonus, real));
        let bet: number = BetManager.Bet;
        let betDenom: number = BetManager.CoinCount;
        let denom: number = BetManager.CoinSize;

        if (FreeRoundBonus.inFrb) {
            if (AppContext.gameDefinition.Gamble && FreeRoundBonus.winPayMethod !== "cumulative") {
                if (GameManager.gameResponse != null && GameManager.gameResponse.balance != null) {
                    let totalRealBalance: number = DataManager.GameRoundClosed ? real : parseFloat(NumberUtils.add(real, win));
                    let totalBalance: number = DataManager.GameRoundClosed ? total : parseFloat(NumberUtils.add(total, win));
                    DataManager.updateGameDataFromModule(GameData.DataBalanceBonus, bonus.toString());
                    DataManager.updateGameDataFromModule(GameData.DataBalanceReal, totalRealBalance.toString());
                    DataManager.updateGameDataFromModule(GameData.DataBalanceTotal, totalBalance.toString());
                    DataManager.updateDataElement(GameData.DataBalanceBonus, bonus.toString());
                    DataManager.updateDataElement(GameData.DataBalanceReal, real.toString());
                    DataManager.updateDataElement(GameData.DataBalanceTotal, totalBalance.toString());
                }
            } else if (!AppContext.gameDefinition.Gamble && !DataManager.Collectable) {
                if (GameManager.gameResponse != null && GameManager.gameResponse.balance != null) {
                    DataManager.updateGameDataFromModule(GameData.DataBalanceBonus, bonus.toString());
                    DataManager.updateGameDataFromModule(GameData.DataBalanceReal, real.toString());
                    DataManager.updateGameDataFromModule(GameData.DataBalanceTotal, total.toString());
                    DataManager.updateDataElement(GameData.DataBalanceBonus, bonus.toString());
                    DataManager.updateDataElement(GameData.DataBalanceReal, real.toString());
                    DataManager.updateDataElement(GameData.DataBalanceTotal, total.toString());
                }
            }
            return;
        }

        if (denom != null && win != null) {
            winDenom = parseFloat(NumberUtils.devide(win, denom));
        }

        if (DataManager.GameRoundClosed) {
            if (bonus != null && bonus > 0 && bonus >= bet) {
                ModuleManager.changeBetColor(true);
                DataManager.updateDataElement(GameData.DataBalanceBonus, NumberUtils.subtract(bonus, bet));
            } else {
                ModuleManager.changeBetColor();
                DataManager.updateDataElement(GameData.DataBalanceReal, NumberUtils.subtract(real, bet));
                if (denom != null && betDenom != null) {
                    DataManager.updateDataElement(
                        GameData.DataBalanceRealDenom,
                        NumberUtils.subtract(realDenom, betDenom),
                    );
                }
            }
            DataManager.updateDataElement(GameData.DataBalanceTotal, NumberUtils.subtract(total, bet));
            DataManager.updateGameDataFromModule(GameData.DataBalanceTotal, NumberUtils.subtract(total, bet));
        } else {
            if (win > 0) {
                if (bonus != null && bonus > 0 && bonus >= bet) {
                    ModuleManager.changeBetColor(true);
                    DataManager.updateDataElement(GameData.DataBalanceBonus, NumberUtils.subtract(bonus, bet));
                    DataManager.updateDataElement(GameData.DataBalanceReal, NumberUtils.add(real, win));
                    if (denom != null && winDenom != null) {
                        DataManager.updateDataElement(
                            GameData.DataBalanceRealDenom,
                            NumberUtils.add(realDenom, winDenom),
                        );
                    }
                } else {
                    ModuleManager.changeBetColor();
                    DataManager.updateDataElement(
                        GameData.DataBalanceReal,
                        NumberUtils.add(NumberUtils.subtract(real, bet), win),
                    );
                    if (denom != null && winDenom != null && betDenom != null) {
                        DataManager.updateDataElement(
                            GameData.DataBalanceRealDenom,
                            NumberUtils.add(NumberUtils.subtract(realDenom, betDenom), winDenom),
                        );
                    }
                }
                DataManager.updateDataElement(
                    GameData.DataBalanceTotal,
                    NumberUtils.add(NumberUtils.subtract(total, bet), win),
                );
                DataManager.updateGameDataFromModule(
                    GameData.DataBalanceTotal,
                    NumberUtils.add(NumberUtils.subtract(total, bet), win),
                );
            } else {
                if (bonus != null && bonus > 0 && bonus >= bet) {
                    ModuleManager.changeBetColor(true);
                    DataManager.updateDataElement(GameData.DataBalanceBonus, NumberUtils.subtract(bonus, bet));
                } else {
                    ModuleManager.changeBetColor();
                    DataManager.updateDataElement(GameData.DataBalanceReal, NumberUtils.subtract(real, bet));
                    if (denom != null && betDenom != null) {
                        DataManager.updateDataElement(
                            GameData.DataBalanceRealDenom,
                            NumberUtils.subtract(realDenom, betDenom),
                        );
                    }
                }
                DataManager.updateDataElement(GameData.DataBalanceTotal, NumberUtils.subtract(total, bet));
                DataManager.updateGameDataFromModule(GameData.DataBalanceTotal, NumberUtils.subtract(total, bet));
            }
        }
    }

    static hasCredit(maxBet: boolean = false, onSpin: boolean = false): boolean {
        let bonus: number = parseFloat(DataManager.getDataById(GameData.DataBalanceBonus));
        let real: number = parseFloat(DataManager.getDataById(GameData.DataBalanceReal));
        let win: number = parseFloat(DataManager.getDataById(GameData.DataTotalWin));
        let bet: number = BetManager.Bet;
        let canPlay: boolean = true;

        if (DataManager.GameRoundClosed) {
            win = 0;
        }

        if (bonus != null && bonus > 0) {
            if (bonus >= bet) {
                ModuleManager.changeBetColor(true);
                return true;
            } else {
                ModuleManager.changeBetColor();
            }
        }

        if (FreeRoundBonus.inFrb) {
            if (AppContext.current) {
                AppContext.current.closeDialog();
            }

            if (CashierDialog.opened) {
                CashierDialog.onClose();
            }

            if (onSpin) {
                FreeRoundBonus.disableUi();
            }

            canPlay = true;
        } else if (real <= 0 || real < bet) {
            var credit: number = parseFloat(NumberUtils.add(real, win));
            if (credit > 0 && credit >= bet) {
                if (AppContext.current) {
                    AppContext.current.closeDialog();
                }

                if (CashierDialog.opened) {
                    CashierDialog.onClose();
                }

                if (onSpin) {
                    FreeRoundBonus.disableUi();
                }

                canPlay = true;
            } else {
                if (AppContext.current && onSpin) {
                    ModuleManager.collect(GameModules.Base);

                    if (AppContext.gameConfiguration.ShowCashierMessage) {
                        CashierDialog.openDialog();
                    } else {
                        AppContext.current.showDialog(Languages.getRid("NOT_ENOUGH_CREDIT"), false);
                    }

                    Platforms.Platforms.clientError("NOT_ENOUGH_CREDIT", Languages.getRid("NOT_ENOUGH_CREDIT"));

                    GameManager.requestSend = false;
                }
                canPlay = false;
            }
        } else {
            if (AppContext.current) {
                AppContext.current.closeDialog();
            }

            if (CashierDialog.opened) {
                CashierDialog.onClose();
            }

            if (onSpin) {
                FreeRoundBonus.disableUi();
            }

            canPlay = true;
        }
        return canPlay;
    }

    static poolingBalance(): void {
        if (
            AppContext != null &&
            AppContext.gameConfiguration != null &&
            AppContext.gameConfiguration.PollCredit > 0 &&
            DataManager.GameRoundClosed
        ) {
            let balance: number = parseFloat(DataManager.getDataById(GameData.DataBalanceReal));
            if (balance != null && BetManager.Bet != null && balance >= BetManager.Bet) {
                return;
            } else {
                if (!BalanceManager._poolBalance) {
                    setTimeout(() => {
                        BalanceManager.refreshBalance();
                    }, AppContext.gameConfiguration.PollCredit);
                    BalanceManager._poolBalance = true;
                }
            }
        }
    }

    static refreshBalance(forced: boolean = false): void {
        if (GameManager.gameClient) {
            GameManager.gameClient.balance().then((response: BalanceResponse) => {
                BalanceManager.balanceReceived(response, forced);
            });
        }
    }

    static balanceReceived(response: IBalance, forced: boolean = false): void {
        BalanceManager._poolBalance = false;
        let bonus: string = response.bonus.toString();
        let real: string = response.real.toString();
        let total: string = NumberUtils.add(response.bonus, response.real);

        DataManager.updateGameDataFromModule(GameData.DataBalanceBonus, bonus);
        DataManager.updateGameDataFromModule(GameData.DataBalanceReal, real);
        DataManager.updateGameDataFromModule(GameData.DataBalanceTotal, total);

        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize) {
            DataManager.updateGameDataFromModule(
                GameData.DataBalanceRealDenom,
                parseInt(NumberUtils.devide(response.real, BetManager.CoinSize)).toString(),
            );
        }

        DataManager.updateDataElement(GameData.DataBalanceBonus, bonus);
        DataManager.updateDataElement(GameData.DataBalanceReal, real);
        DataManager.updateDataElement(GameData.DataBalanceTotal, total);

        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize) {
            DataManager.updateDataElement(
                GameData.DataBalanceRealDenom,
                parseInt(NumberUtils.devide(response.real, BetManager.CoinSize)).toString(),
            );
        }
        BalanceManager.poolingBalance();

        Platforms.Platforms.balanceUpdated({ amount: parseFloat(total), forced: forced });
    }

    static recalculateDenomBalance(): void {
        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataBalanceRealDenom,
                parseInt(
                    NumberUtils.devide(
                        parseFloat(DataManager.getDataById(GameData.DataBalanceReal)),
                        BetManager.CoinSize,
                    ),
                ).toString(),
            );
            DataManager.updateDataElement(
                GameData.DataBalanceRealDenom,
                parseInt(
                    NumberUtils.devide(
                        parseFloat(DataManager.getDataById(GameData.DataBalanceReal)),
                        BetManager.CoinSize,
                    ),
                ).toString(),
            );
        }
    }

    private static log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup("BalanceManager", s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Managers/BalanceManager.ts
 **/